/**
 * Renders non-reversal line items that are not listed in the
 * `LINE_ITEMS` array in util/types.js
 *
 * The line items are rendered so that the line item code is formatted to human
 * readable form and the line total is printed as price.
 *
 * If you require another kind of presentation for your line items, add them to
 * the `LINE_ITEMS` array in util/types.js and create a specific line item
 * component for them that can be used in the `OrderBreakdown` component.
 */
import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { humanizeLineItemCode, isValidUUIDv4 } from '../../util/data';
import { LINE_ITEMS, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemUnknownItemsMaybe = props => {
  const { lineItems, isProvider, intl, cartListings } = props;

  // resolve unknown non-reversal line items
  const allItems = lineItems.filter(item => LINE_ITEMS.indexOf(item.code) === -1 && !item.reversal && !item.code.includes("line-item/TAX-"));

  const items = isProvider
    ? allItems.filter(item => item.includeFor.includes('provider'))
    : allItems.filter(item => item.includeFor.includes('customer'));

  return items.length > 0 ? (
    <React.Fragment>
      {items.map((item, i) => {
        const quantity = item.quantity;
        const formattedTotal = formatMoney(intl, item.lineTotal);
        const listingId = item.code.split('line-item/')[1];
        const isUUIDListing = isValidUUIDv4(listingId);

        // Get listing details from cartListings if available
        const cartListing = isUUIDListing && Array.isArray(cartListings) ? cartListings.find(l => l?.id==listingId ||  l?.id?.uuid === listingId) : cartListings && cartListings.length > i ? cartListings[i] : null;
        const listingTitle = cartListing?.attributes?.title;
        const variantLabel = cartListing?.variantLabel;

        // If we have listing title, use it with quantity. Otherwise use humanized code
        const label = isUUIDListing && listingTitle ? (quantity && quantity > 0 ? `${listingTitle} x ${quantity}` : listingTitle)
         : listingTitle
          ? (quantity && quantity > 1 ? `${listingTitle} x ${quantity}` : listingTitle)
          : (quantity && quantity > 0
              ? `${humanizeLineItemCode(item.code)} x ${quantity}`
              : humanizeLineItemCode(item.code));

        return (
          <div key={`${i}-item.code`} className={css.lineItem}>
            <div className={css.itemLabelWrapper}>
              <span className={css.itemLabel}>{label}</span>
              {variantLabel && (
                <div className={css.variantLabel}>{variantLabel}</div>
              )}
            </div>
            <span className={css.itemValue}>{formattedTotal}</span>
          </div>
        );
      })}
    </React.Fragment>
  ) : null;
};

LineItemUnknownItemsMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemUnknownItemsMaybe;
